import React from "react";
import "react-toastify/dist/ReactToastify.css";
import CustomModal from "./../../../components/ReactModal";

export const PendingSuccessModal = ({props}) => {
    return (
        <CustomModal>
        <div className="tw-bg-white tw-mx-auto tw-rounded-md tw-p-4">
          <p className="tw-text-lg text-center my-2 font-light tw-text-black">Property Review Request Sent</p>
          <div className="p-4 bg-white rounded-b-xl">
              <p className="tw-text-sm text-center">
                Property successfully submitted for review
              </p>
              <p className="tw-text-sm text-center">
                Review may take up to 48 hours
              </p>
          </div>
          <div className="tw-flex tw-items-center tw-justify-center tw-space-x-2">
            <button
              onClick={() => {
                props.history.push("/booking/availability");
              }}
              className="btn btn-sm btn-primary"
            >
              Go to Booking Calendar
            </button>
          </div>
        </div>
      </CustomModal>
)
}